import { browserLogger } from '@widget/utils/datadog';

import type { ZipCodeType } from '@widget/api/queries/zipcodes/types';

const MAX_SUGGESTIONS_COUNT = 10;
export const filterZipCodes =
  ({
    zipCode,
    city,
    maxCount = MAX_SUGGESTIONS_COUNT,
    market = 'DE',
    isFetching = false,
  }: {
    zipCode?: string;
    city?: string;
    maxCount?: number;
    market?: string;
    isFetching?: boolean;
  }) =>
  (options: ZipCodeType[]) => {
    if ((!zipCode && !city) || options === undefined || isFetching) return [];

    // search on city AND zip
    if (zipCode && city) {
      const zipAndCityList =
        options
          ?.filter(
            (row) =>
              row.zipCode?.indexOf(zipCode) !== -1 &&
              row.city?.toLowerCase().indexOf(city.toLocaleLowerCase()) !== -1,
          )
          .slice(0, maxCount) || [];
      if (zipAndCityList.length) return zipAndCityList;
      // search on zip AND region if no city
      const optionWithZip = options.find((row) => row.zipCode === zipCode);
      if (optionWithZip)
        return [
          {
            zipCode: optionWithZip.zipCode,
            city: undefined,
            region: optionWithZip.region,
          },
        ];

      return [];
    }
    // search on city OR zip
    const zipOrCityList = options
      ?.filter((row) => {
        return (
          (zipCode && row.zipCode?.indexOf(zipCode) === 0) ||
          (city && row.city?.toLowerCase().indexOf(city.toLowerCase()) === 0)
        );
      })
      .slice(0, maxCount);
    if (zipOrCityList?.length) return zipOrCityList;

    const IS_VALID_ZIPCODE =
      (market === 'at' && zipCode?.length === 4) || (market === 'de' && zipCode?.length === 5);

    if (zipCode && IS_VALID_ZIPCODE) {
      browserLogger.warn({ zipCode, message: 'Zipcode not found in list' }, 'lead');
    }
    return [];
  };
